import auth from "./auth";
import sistem from "./sistem";
import laman from "./laman";
import area from "./area";
import user from "./user";
import trainer_divisi from "./trainer_divisi";
import client from "./client";
import trainer from "./trainer";
import materi from "./materi";
import training from "./training";
import pel_client from "./pel_client";

export default {
  auth,
  sistem,
  laman,
  area,
  user,
  trainer_divisi,
  client,
  trainer,
  materi,
  training,
  pel_client
};
